import { StyleSheet, View } from 'react-native'
import { DS } from '../../../../../../design-system'
import Chip from '../../../../../../design-system/Icons/Chip.svg'
import { numberWithCommas } from '../../../../../../utils/numberWithCommas'
interface SectionProps {
  title: string
  value: string | number
  showChip?: boolean
}

export const Section = ({ title, value, showChip }: SectionProps) => {
  const valueText = typeof value === 'string' ? value : value

  return (
    <View style={styles.container}>
      <View style={{ flexDirection: 'row', justifyContent: 'center', gap: 8 }}>
        <DS.Text variant="Caption/Bold" textAlign="center">
          {numberWithCommas(valueText)}
        </DS.Text>
        {showChip ? <Chip color={'black'} height={16} width={16} /> : null}
      </View>
      <DS.Text variant="Mini/Medium" textAlign="center" uppercase>
        {numberWithCommas(title)}
      </DS.Text>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    gap: 5
  }
})
